import { ArrowLeft } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { Switch } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/switch";
import { useNavigate } from "react-router-dom";

const NotificationSettings = () => {
  const navigate = useNavigate();

  const notificationGroups = [
    {
      title: "Meal Reminders",
      items: [
        { label: "Breakfast reminder", enabled: true },
        { label: "Lunch reminder", enabled: true },
        { label: "Dinner reminder", enabled: false },
        { label: "Water intake reminder", enabled: true },
      ],
    },
    {
      title: "Activity Notifications",
      items: [
        { label: "Daily step goal achieved", enabled: true },
        { label: "Inactivity alerts", enabled: false },
        { label: "Workout suggestions", enabled: true },
      ],
    },
    {
      title: "Health Alerts",
      items: [
        { label: "Medication reminders", enabled: true },
        { label: "Sleep schedule reminder", enabled: true },
        { label: "Heart rate alerts", enabled: false },
      ],
    },
    {
      title: "App Updates",
      items: [
        { label: "Feature updates", enabled: true },
        { label: "Tips and insights", enabled: true },
        { label: "Weekly summary", enabled: true },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="mx-auto max-w-md">
        {/* Header */}
        <div className="flex items-center gap-3 border-b border-border/50 p-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/profile")}
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-xl font-bold text-foreground">Notifications</h1>
            <p className="text-xs text-muted-foreground">Manage your alerts</p>
          </div>
        </div>

        <div className="space-y-4 p-4">
          {notificationGroups.map((group, groupIndex) => (
            <Card
              key={groupIndex}
              className="rounded-2xl border-0 p-5 shadow-sm"
            >
              <h3 className="mb-4 font-semibold text-foreground">
                {group.title}
              </h3>
              <div className="space-y-4">
                {group.items.map((item, itemIndex) => (
                  <div
                    key={itemIndex}
                    className="flex items-center justify-between"
                  >
                    <span className="text-sm text-foreground">
                      {item.label}
                    </span>
                    <Switch defaultChecked={item.enabled} />
                  </div>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
